/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from "@ngrx/store";
import { AnnotationSettings, CurrentSelectionResult, DisplayUnit, RevitInformation } from "../../models/annotation-settings";
import { GetAnnotationSettingsFromXMLFileSuccess, GetFittingsTagLocationPathSuccess, GetRevitInformationSuccess, GetTagLocationPathSuccess, IsCurrentSelectionValidSuccess } from "./annotation-settings-actions";

export const AnnotationSettingsKey = "AnnotationSettings";

export interface AnnotationSettingsState {
    annotationSettings?: AnnotationSettings;
    revitInformation?: RevitInformation;
    tagLocationPath?: string;
    fittingsTagLocationPath?: string;
    currentSelectionResult?: CurrentSelectionResult;
}

export const initialAnnotationSettingsState = {
    annotationSettings: null,
    revitInformation: new RevitInformation(),
    tagLocationPath: '',
    fittingsTagLocationPath: '',
    currentSelectionResult: new CurrentSelectionResult()
};

export const AnnotationSettingsReducer = createReducer(
    initialAnnotationSettingsState,
    on(GetAnnotationSettingsFromXMLFileSuccess, (state, action) => ({
        ...state,
        annotationSettings: action.response,
    })),

    on(GetRevitInformationSuccess, (state, action) => ({
        ...state,
        revitInformation: action.response,
    })),
     
    on(GetTagLocationPathSuccess, (state, action) => ({
        ...state,
        tagLocationPath: action.response,
    })),

    on(GetFittingsTagLocationPathSuccess, (state, action) => ({
      ...state,
      fittingsTagLocationPath: action.response,
  })),
      
    on(IsCurrentSelectionValidSuccess, (state, action) => ({
        ...state,
        currentSelectionResult: action.response,
    }))
);